/**
 * Canonieke Kleda-claims — machine-leesbare afgeleide van SSOT §6B
 * (brands/kleda/docs/SSOT.md). Bij wijziging: ALTIJD eerst de SSOT
 * aanpassen, daarna dit bestand. De SSOT is de menselijke waarheid,
 * dit bestand is de bron voor de React-apps.
 */

/** Harde feiten — alleen deze getallen gebruiken (SSOT §6) */
export const KLEDA_FACTS = {
  /** Gemiddelde beoordeling over álle reviewbronnen */
  reviewScore: '9,5',
  /** Totaal aantal reviews over álle bronnen — herijken bij elke mijlpaal, nooit terugtellen */
  reviewCount: '10.700+',
  /** Jaren ervaring */
  jarenErvaring: '35',
  /** Tevredenheidsgarantie in dagen (Kleda) */
  garantieDagen: 30,
  /** Doorlooptijd ophalen → afleveren */
  doorlooptijd: '5-10 werkdagen',
  /** Minimum orderwaarde */
  minimumTarief: '€ 99',
  /** Kleden per jaar */
  kledenPerJaar: '10.000+',
  /** Gratis opslagdagen na gereedmelding (moet gelijk zijn aan OPSLAGKOSTEN_CONFIG.GRATIS_DAGEN) */
  opslagGratisDagen: 28,
  /** Opslagkosten per week na de gratis periode (incl. BTW) */
  opslagPerWeek: '€10',
} as const

/** Canonieke zinnen — letterlijk gebruiken in elk touchpoint (SSOT §6B) */
export const KLEDA_CLAIMS = {
  /** Review-claim, volledige zin */
  review: `Klanten beoordelen ons gemiddeld met een ${KLEDA_FACTS.reviewScore} — op basis van ${KLEDA_FACTS.reviewCount} reviews.`,
  /** Review-claim, kort (badges/footers) */
  reviewKort: `${KLEDA_FACTS.reviewScore} uit ${KLEDA_FACTS.reviewCount} reviews`,
  /** Betaal-zin, volledig. NOOIT "pas na aflevering" of "pas betalen als je tevreden bent". */
  betalen: 'Betalen kan vooraf via iDEAL, of bij aflevering met pin of contant (gepast). Jij kiest — vooruitbetalen is nooit verplicht.',
  /** Betaal-zin, kort (badges) */
  betalenKort: 'Betaal vooraf of bij aflevering',
  /** Doorlooptijd-zin */
  doorlooptijd: 'Binnen 5–10 werkdagen schoon weer thuis.',
  /** Garantie-zin, volledig */
  garantie: 'Niet tevreden? Binnen 30 dagen na bezorging lossen we het op — met een herreiniging of passende compensatie.',
  /** Garantie, kort (badges) */
  garantieKort: '30 dagen tevredenheidsgarantie',
  /** Opslag-zin */
  opslag: `De eerste ${KLEDA_FACTS.opslagGratisDagen} dagen bewaren we je kleed gratis. Daarna rekenen we ${KLEDA_FACTS.opslagPerWeek} per week opslagkosten.`,
  /** Ophalen & bezorgen */
  ophalen: 'Gratis ophalen en bezorgen, door heel Nederland.',
  /** Ophalen, kort (badges) */
  ophalenKort: 'Gratis ophalen en bezorgen',
  /**
   * Werkgebied-zin: waar de vraag "komen jullie ook bij mij?" speelt (SSOT §6B).
   * Zuid-Limburg (61xx-64xx) is een partnergebied: de partner maakt daar de
   * offerte, nooit een Kleda-prijs. Plan 2026-09-15.
   */
  werkgebied: 'We halen op door heel Nederland. In Zuid-Limburg werken we samen met een partner-specialist, die maakt daar een offerte op maat. Vul je postcode in en je ziet het direct.',
  /** Geur-regel (pakketkeuze, grootste klachtbron). Premium Plus bevat GEEN ontgeuren. */
  geurRegel: 'Zit er geur in je kleed (huisdier, urine, rook of muf)? Kies dan Huisdier Compleet; dat pakket bevat de ontgeurbehandeling. Geen geur? Dan heb je het niet nodig.',
  /** Wat de ontgeurbehandeling is — gebruik overal waar de behandeling wordt genoemd (SSOT §6B) */
  geurBehandeling: 'Ontgeurbehandeling op enzymatische basis. De enzymen breken de geurbron in de vezel af, in plaats van de geur te maskeren met parfum.',
  /**
   * Grens van de ontgeurbehandeling. VERPLICHT bij elke ontgeur-claim (SSOT §6B).
   * Nooit een volledig of gegarandeerd geurresultaat beloven: geen "garantie",
   * geen "100%", geen "volledig weg". De remedie is de gewone 30-dagen
   * tevredenheidsgarantie (KLEDA_CLAIMS.garantie), niet een aparte geurgarantie.
   */
  geurGrens: 'Is urine tot in de rug van het kleed getrokken, dan kan er restgeur achterblijven. Zien we dat bij de voorinspectie, dan hoor je het van ons voordat we behandelen.',
  /** Ervaring, kort (badges) */
  ervaringKort: '35 jaar vakmanschap',
} as const
